import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=9b6c5e66"
import script from "./Widget.ts?vue&type=script&lang=ts&external"
export * from "./Widget.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports